import { render, staticRenderFns } from "./FieldDefinitionTable.vue?vue&type=template&id=bc279044&scoped=true&"
import script from "./FieldDefinitionTable.vue?vue&type=script&lang=js&"
export * from "./FieldDefinitionTable.vue?vue&type=script&lang=js&"
import style0 from "./FieldDefinitionTable.vue?vue&type=style&index=0&id=bc279044&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc279044",
  null
  
)

export default component.exports